<template>
    <div>
        <template v-if="custom_reporting === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Custom Reports</h1>
                <router-link to="/assignCustomReport" class="btn btn-primary float-right active"> Assign custom report</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="customReportTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Parent Company</th>
                        <th>Reporting Company</th>
                        <th>User</th>
                        <th>Created By</th>
                        <th>Bifurcation</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="custom_reporting === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="custom_reporting === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                custom_reporting: null
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('custom_reporting').then(result => {
                this.custom_reporting = result.custom_reporting;
            }).then(result => {
                if(this.custom_reporting == true){
                    this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            callDataTable(){
                var that = this;
                var customReportTable = $('#customReportTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listCustomReport",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records"
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
                        {render: function(data,type,full){
                            if(full.company != null){
                                return full.company.name;
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.rcompany != null){
                                return full.rcompany.name;
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.user != null){
                                return full.user.name;
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.createdby != null){
                                return full.createdby.name;
                            }
                        }},
                        {data: 'bifurcation'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editCustomReport/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 5 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    customReportTable.search(this.value).draw();
                });
            }
        }
    }
</script>
